import LegalPage, { LegalSection, LegalList } from "@/components/site/LegalPage";

export default function TermsAndConditions() {
  return (
    <LegalPage
      title="Termeni și Condiții"
      eyebrow="Cadru contractual"
      subtitle="Regulile de utilizare a site-ului AutoRIO și condițiile generale în relația cu vizitatorii și clienții."
      seoDesc="Termeni și condiții AutoRIO — reguli de utilizare a site-ului, oferte, contact, limitări."
      path="/termeni-si-conditii"
    >
      <LegalSection title="Preambul">
        <p>
          Prin accesarea și utilizarea site-ului AutoRIO, ești de acord cu
          termenii și condițiile prezentate mai jos. Dacă nu ești de acord cu
          aceștia, te rugăm să nu utilizezi acest site.
        </p>
        <p>
          Site-ul este administrat de{" "}
          <span className="text-white font-semibold">ODI MEGA TRANS S.R.L.</span>{" "}
          — CUI: RO35133743, J2015000946337, cu sediul social în [adresa
          completă], denumită în continuare „AutoRIO”.
        </p>
      </LegalSection>

      <LegalSection title="Definiții">
        <LegalList
          items={[
            "„Site” — platforma web accesibilă prin domeniul autorio.ro și subdomeniile acestuia.",
            "„Utilizator” — orice persoană care accesează site-ul, indiferent de motiv.",
            "„Client” — persoana care intră în contact cu AutoRIO prin formulare, telefon, WhatsApp sau alte canale, în vederea unei oferte.",
            "„Anunț” — prezentarea unui autoturism disponibil în stoc, cu specificațiile, prețul și imaginile aferente.",
          ]}
        />
      </LegalSection>

      <LegalSection title="Obiectul site-ului">
        <p>
          Site-ul are ca scop prezentarea autoturismelor second-hand din stocul
          AutoRIO, oferirea de informații privind serviciile complementare
          (finanțare, Buy Back, livrare, consultanță) și facilitarea
          contactului între potențialii clienți și dealer.
        </p>
        <p>
          Site-ul nu constituie o ofertă contractuală în sens legal. Toate
          informațiile publicate au caracter informativ, iar termenii finali
          se stabilesc de comun acord la momentul contractării.
        </p>
      </LegalSection>

      <LegalSection title="Ofertele și prețurile afișate">
        <p>
          Prețurile afișate sunt exprimate în EUR, includ TVA și sunt valabile
          la data afișării. AutoRIO își rezervă dreptul de a modifica
          prețurile, specificațiile sau disponibilitatea unui autoturism
          fără notificare prealabilă.
        </p>
        <LegalList
          items={[
            "Fotografiile au caracter orientativ; culorile și detaliile pot varia față de aspectul real.",
            "Specificațiile tehnice sunt preluate din documentele mașinii sau declarate de proprietarul precedent; recomandăm verificarea acestora la vizionare.",
            "Ofertele de finanțare provin de la partenerii noștri financiari și sunt supuse condițiilor și aprobării acestora.",
          ]}
        />
      </LegalSection>

      <LegalSection title="Utilizarea site-ului">
        <p>Utilizatorii se obligă:</p>
        <LegalList
          items={[
            "Să utilizeze site-ul în mod legal, cu bună-credință și doar în scop personal / comercial legitim.",
            "Să nu încerce accesarea neautorizată a zonelor restricționate.",
            "Să nu folosească roboți, scripturi sau alte metode automate pentru extragerea masivă de date.",
            "Să nu publice conținut ilegal, ofensator sau care încalcă drepturile terților.",
          ]}
        />
        <p>
          Orice utilizare abuzivă poate duce la restricționarea accesului și,
          după caz, la sesizarea autorităților competente.
        </p>
      </LegalSection>

      <LegalSection title="Proprietate intelectuală">
        <p>
          Toate elementele site-ului (design, logo, texte, fotografii, cod
          sursă) sunt proprietatea AutoRIO sau a partenerilor săi și sunt
          protejate de legislația privind drepturile de autor și proprietatea
          intelectuală.
        </p>
        <p>
          Reproducerea, distribuirea sau modificarea acestor materiale, fără
          acordul scris prealabil, este interzisă.
        </p>
      </LegalSection>

      <LegalSection title="Limitarea răspunderii">
        <p>
          AutoRIO depune toate diligențele pentru ca informațiile de pe site să
          fie corecte și actualizate. Cu toate acestea, nu garantăm acuratețea
          absolută a informațiilor și nu putem fi ținuți răspunzători pentru:
        </p>
        <LegalList
          items={[
            "Erori de introducere sau afișare (fotografii, specificații, prețuri).",
            "Indisponibilitatea temporară a site-ului din motive tehnice.",
            "Decizii ale terților (parteneri financiari, transportatori) care nu depind de AutoRIO.",
          ]}
        />
      </LegalSection>

      <LegalSection title="Protecția datelor personale">
        <p>
          Prelucrarea datelor personale colectate prin formularele site-ului
          este descrisă în{" "}
          <a
            href="/politica-confidentialitate"
            className="text-[#D4AF37] font-semibold hover:underline"
          >
            Politica de Confidențialitate
          </a>
          . Prin trimiterea unei cereri, îți exprimi acordul cu prelucrarea
          datelor tale în scopul procesării acesteia.
        </p>
      </LegalSection>

      <LegalSection title="Cookies">
        <p>
          Site-ul utilizează cookie-uri conform{" "}
          <a
            href="/politica-cookie"
            className="text-[#D4AF37] font-semibold hover:underline"
          >
            Politicii Cookie
          </a>
          .
        </p>
      </LegalSection>

      <LegalSection title="Soluționarea litigiilor">
        <p>
          Orice litigiu se va soluționa pe cale amiabilă, prin dialog direct.
          În cazul în care acest lucru nu este posibil, consumatorii pot apela
          la:
        </p>
        <LegalList
          items={[
            "Autoritatea Națională pentru Protecția Consumatorilor — ANPC (www.anpc.ro).",
            "Platforma SAL (Soluționarea Alternativă a Litigiilor): reclamatiisal.anpc.ro",
            "Platforma SOL (Soluționarea Online a Litigiilor): ec.europa.eu/consumers/odr",
          ]}
        />
        <p>
          Litigiile care nu pot fi soluționate amiabil vor fi supuse instanței
          competente de la sediul AutoRIO.
        </p>
      </LegalSection>

      <LegalSection title="Modificări">
        <p>
          AutoRIO își rezervă dreptul de a modifica prezentul document în orice
          moment. Versiunea aplicabilă este cea publicată pe site la momentul
          accesării.
        </p>
      </LegalSection>

      <LegalSection title="Contact">
        <p>
          Pentru orice întrebare referitoare la acești termeni, folosește
          pagina{" "}
          <a
            href="/contact"
            className="text-[#D4AF37] font-semibold hover:underline"
          >
            Contact
          </a>
          .
        </p>
      </LegalSection>
    </LegalPage>
  );
}
